import { useUserStore } from "@libs/acp/store/user/useUserStore";

const useAuthenticatedUser = () => {
	const authenticatedUser = useUserStore(
		(state) => state.authenticatedUser.acp,
	);

	const resetStore = useUserStore((state) => state.resetStore);

	const acpLogout = useUserStore((state) => state.resetACP);

	const updateACPUSerContactStatus = useUserStore(
		(state) => state.updateACPUSerContactStatus,
	);

	const addAuthenticatedUser = useUserStore(
		(state) => state.addAuthenticatedUser,
	);

	const updateACPCustomer = useUserStore((state) => state.updateACPCustomer);

	const updateUserContactStore = (data: {
		type: "email" | "celular" | "socialName";
		email?: string;
		celular?: string;
		socialName?: string;
	}) => {
		updateACPCustomer(data);
	};

	const hasPermission = useUserStore((state) => state.hasPermission);
	const containsPermissionGroup = useUserStore(
		(state) => state.containsPermissionGroup,
	);

	const tokenOrigin = useUserStore((state) => state.tokenOrigin);
	const updateACPAuthSession = useUserStore(
		(state) => state.updateACPAuthSession,
	);

	return {
		authenticatedUser,
		resetStore,
		updateACPUSerContactStatus,
		updateACPCustomer,
		updateUserContactStore,
		hasPermission,
		containsPermissionGroup,
		tokenOrigin,
		updateACPAuthSession,
		acpLogout,
		addAuthenticatedUser,
	};
};

export default useAuthenticatedUser;
